import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { ErrorBoundary } from '@/components/feedback';
import { Spinner } from '@/components/ui';

import { Footer } from '../Footer';
import { Header } from '../Header';
import { ScrollToTop } from '../ScrollToTop';

import styles from './RootLayout.module.css';

/**
 * Shell shared by every route: skip link and header, the routed page, footer.
 * Lazily-loaded pages suspend inside `main`, so the chrome never flashes.
 */
export function RootLayout() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <main id="main-content" className={styles.main} tabIndex={-1}>
        <ErrorBoundary>
          <Suspense fallback={<Spinner label="Loading page" />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </main>
      <Footer />
    </>
  );
}
